import { getClientTypeSync, CLIENT_TYPE, isWechat, isWXMiniProgram, isMMP } from '@cap/utils';
import { isBrowser } from '@cap/ssr-common-utils';
import { DOMAIN_MAP, REACT_APP_ENV_MAP } from '../../constants';

// 非微信小程序微信环境
export const isWXBrower = (ua: string) => {
  return isWechat(ua) && !isWXMiniProgram(ua);
};

// 是否微信环境
export const isWX = (ua: string) => {
  return isWechat(ua) && !isMMP(ua);
};

/**
 * 是否local环境
 * @param curr
 * @returns
 */
export const isLocalEnv = (curr: string) => curr === REACT_APP_ENV_MAP.local;

/**
 * 是否 prod 和 st环境
 * @param curr
 * @returns
 */
export const isProdEnv = (curr: string) =>
  curr === REACT_APP_ENV_MAP.production || curr === REACT_APP_ENV_MAP.staging;

/**
 * 是否test环境
 * @param curr
 * @returns
 */
export const isTestEnv = (curr: string) => curr === REACT_APP_ENV_MAP.test;

/**
 * 仅prod环境
 */
export const isOnlyProdEnv = (curr: string) => curr === REACT_APP_ENV_MAP.production;

/**
 * 获取ClientType
 * @param ua
 * @returns
 */
export const getFrom = (ua?: string) => {
  // ssr 场景下，未传递ua值，则直接返回 unknown
  if (!isBrowser && !ua) {
    return CLIENT_TYPE.unknown;
  }
  return getClientTypeSync((ua || navigator.userAgent).toLowerCase()) || CLIENT_TYPE.unknown;
};
/**
 * 获取对应环境的域名Url
 * @param env
 * @returns
 */
export const getEnvUrl = (env: string) => {
  const curEnv = env || 'local';
  return DOMAIN_MAP[curEnv];
};

export const isMaoYan = (ua?: string) => {
  return CLIENT_TYPE.maoyan === getFrom(ua);
};

/**
 * 当前运行时环境，可能不准。从 globalThis.runtime_env?.env
 * @returns
 */
// export const currentAppEnv = () => {
//   return globalThis.runtime_env?.env;
// };

/**
 * 是否在iframe中运行
 */
export const isInFrame = () => isBrowser && window.top !== window.self;
